import { basename } from "./path";

/** Delay before revoking a download's object URL: revoking immediately can cancel the download. */
const OBJECT_URL_REVOKE_DELAY_MS = 60_000;

export function downloadFile(name: string, url: string) {
  const link = document.createElement("a");
  link.download = basename(name);
  link.href = url;
  link.click();
}

/**
 * Save in-memory bytes as `name`, via a same-origin object URL so `download` applies (it is ignored
 * on cross-origin URLs).
 */
export function downloadBlob(name: string, blob: Blob) {
  const objectUrl = URL.createObjectURL(blob);
  downloadFile(name, objectUrl);
  setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_REVOKE_DELAY_MS);
}
